import { createContext } from 'react';
/**
 * This context is used to pass a current page url from the front end
 * application to the component library. This is used to match
 * hrefs within navigation, for example, and then highlight that link
 * @example
 * const currentPageUrl = useContext(CurrentUrlContext);
 * const activeLink = href === currentPageUrl
 */

var CurrentUrlContext = createContext(null);
export default CurrentUrlContext;